export const countries = [
  {
    name: "Deutschland",
    code: "DE",
  },
  {
    name: "Niederlande",
    code: "NL",
  },
  {
    name: "Belgien",
    code: "BE",
  },
  {
    name: "Luxemburg",
    code: "LU",
  },
  {
    name: "Frankreich",
    code: "FR",
  },
  {
    name: "Schweiz",
    code: "CH",
  },
  {
    name: "Österreich",
    code: "AT",
  },
  {
    name: "Tschechien",
    code: "CZ",
  },
  {
    name: "Polen",
    code: "PL",
  },
  {
    name: "Dänemark",
    code: "DK",
  },
];



// WEBPACK FOOTER //
// /agir/src/app/components/subscription/subscription-address/countries.ts